import {Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {ApplicantDetailsComponent} from '../../../shared/components/applicant-details/applicant-details.component';
import {AddressDetailsComponent} from '../../../shared/components/address-details/address-details.component';
import {WorkrequestChmComponent} from '../workrequest-chm/workrequest-chm.component';
import {LoginService} from '../../../shared/services/login.service';
import {ChmService} from '../chm.service';
import {Router} from '@angular/router';
import {FormControl, Validators} from '@angular/forms';
import {PlumberDetailsComponent} from '../../../shared/components/plumber-details/plumber-details.component';
import {PlumberDetails} from '../../../shared/data-objects/plumber-details';
import {Steps} from 'primeng/primeng';
import {IppaymentComponent} from '../../../shared/components/ippayment/ippayment.component';
import {IppaymentService} from '../../../shared/services/ippayment.service';
import {ApplicationFormBase} from '../../../shared/data-objects/application-form-base';
import * as MenuUtils from '../../../shared/data-objects/menu-item-ex';
import {Chm} from '../chm';
import {ApplicationBase} from '../../../shared/data-objects/application-base';
import {WorkrequestChmViewmodel} from '../workrequest-chm-viewmodel';
import {Meta} from '@angular/platform-browser';
import { AddressService } from '../../../shared/services/address.service';

const referenceNumberRE = /^[a-zA-Z0-9\-\/\.\:]+$/;

Steps.prototype.itemClick = MenuUtils.itemClick;

@Component({
  selector: 'app-chm',
  templateUrl: 'chm.component.html',
  styleUrls: ['chm.component.css'],
  entryComponents: [ApplicantDetailsComponent, AddressDetailsComponent, WorkrequestChmComponent, PlumberDetailsComponent,
    IppaymentComponent],
  encapsulation: ViewEncapsulation.None
})

export class ChmComponent extends ApplicationFormBase<Chm> implements OnInit {
  isRequesting: boolean;
  refNumControl: FormControl;
  refNumControlLength = 11;

  wwPricingZone: boolean = false;

  @ViewChild('WorkrequestComponent') workrequestComponent: WorkrequestChmComponent;
  @ViewChild('PlumberDetailsComponent') plumberDetailsComponent: PlumberDetailsComponent;

  constructor(protected loginService: LoginService, private addressService: AddressService,
              private chmService: ChmService, protected ipPaymentService: IppaymentService, protected router: Router, private meta: Meta) {
    super(chmService, loginService, ipPaymentService, router);
    this.refNumControl = new FormControl('', [Validators.maxLength(this.refNumControlLength), Validators.pattern(referenceNumberRE)]);
    this.meta.updateTag({ name: 'description', content: 'Request the supply of potable and/or recycled water to existing buildings; all properties must be either separately titled or rated.' });
  }

  async ngOnInit() {
    let isTokenValid = await this.loginService.isTokenValid();
    if(!isTokenValid) {
      if(this.loginService.isGuestUserLoggedIn()) {
        this.loginService.guestLogin((ok: boolean)=>{
          this.setupTotalOrderAmount();
          this.setupTabs();
        });
      } else {
        this.router.navigate(['/login']);
      }
    } else {
      await this.loginService.refreshToken();
      this.setupTotalOrderAmount();
      this.setupTabs();
    }
  }

  setupTotalOrderAmount(): void {
    this.ipPaymentService.paymentformIsInit.subscribe((data: any) => {
      this.paymentformIsInit(5, this.workrequestComponent.totalOrderAmount);
    });
  }

  setupTabs(): void {
    const me = this;

    //if (!this.loginService.isGuestUserLoggedIn()) {
    if (this.loginService.isUserLoggedIn()) {
      if (this.loginService.isUserBillLater()) {
        this.setApplicantDetailsForBillLater(this.chmService.applicationData.applicant);
        this.addMenuItem('Location details', me, 0, 'First Step');
        this.addMenuItem('Work request', me, 1, 'Second Step');
        this.addMenuItem('Plumber details', me, 2, 'Third Step');
        this.addMenuItem('Applicant details', me, 3, 'Fourth Step');
        this.addMenuItem('Review and submit', me, 4, 'Fifth Step');
      } else {
        //this.setApplicantDetailsForGuestUser(this.chmService.applicationData.applicant);
        this.setApplicantDetailsForNonBillLater(this.chmService.applicationData.applicant);
        this.addMenuItem('Location details', me, 0, 'First Step');
        this.addMenuItem('Work request', me, 1, 'Second Step');
        this.addMenuItem('Plumber details', me, 2, 'Third Step');
        this.addMenuItem('Applicant details', me, 3, 'Fourth Step');
        this.addMenuItem('Review and submit', me, 4, 'Fifth Step');
        this.addMenuItem('Payment', me, 5, 'Sixth Step');
      }
      this.loadFees();
    }
  }

  onFeeCodesReceived(): void {
  }

  getTotalOrderAmount(): number {
    return this.workrequestComponent.totalOrderAmount;
  }

  get commitDisabled(): boolean {
    return (
      !this.chmService.agreedToTsAndCs ||
      this.applicant.invalid ||
      this.location.invalid ||
      this.workrequestComponent.invalid ||
      this.plumberDetailsComponent.invalid
    );
  }

  get plumberDetails(): PlumberDetails {
    return this.chmService.applicationData.plumberDetails;
  }

  get workRequestViewModel(): WorkrequestChmViewmodel {
    return this.chmService.workRequestViewModel;
  }

  closeModal() {
    this.wwPricingZone = false;
  }

  canGoNext(executeYes: any, executeNo: any): void {
    this.chmService.submitErrorMessage = '';

    if (this.activeIndex === 0) {
      // this.navigateFromLocation(executeYes, executeNo);
      this.addressService.getPricingZone().subscribe(_pricingzone => {
        console.log(_pricingzone.toUpperCase());
        if (_pricingzone && _pricingzone.toUpperCase() === 'FMR CWW') {
          this.wwPricingZone = false;
          this.navigateFromLocation(executeYes, executeNo);
          return;
        } else {
          this.wwPricingZone = true;
          executeNo();
        }
      }, err => {
        executeNo();
        return;
      });
    } else if (this.activeIndex === 1) {
      const errMsg = this.workrequestComponent.displayErrorMessage();
      if (!this.workrequestComponent.invalid && errMsg.length > 0) {
        executeNo();
      } else {
        executeYes();
      }
    } else if (this.activeIndex === 2) {
      this.plumberDetailsComponent.errorMessage = null;
      if (this.plumberDetailsComponent.invalid && this.plumberDetailsComponent.displayErrorMessage().length > 0) {
        this.plumberDetailsComponent.displayErrorMessage();
        executeNo();
      } else {
        executeYes();
      }
    } else if (this.activeIndex === 3) {
      if (this.applicant.invalid && this.applicant.displayErrorMessage().length > 0) {
        this.chmService.submitErrorMessage += this.applicant.displayErrorMessage();
        executeNo();
        return;
      }
      if (this.refNumControl.hasError('maxlength')) {
        this.chmService.submitErrorMessage += 'Customer order/reference number cannot exceed ' + this.refNumControlLength + ' characters';
        executeNo();
        return;
      }
      if (this.refNumControl.hasError('pattern')) {
        this.chmService.submitErrorMessage += 'Please enter valid Customer order/reference number; ' +
          'Alphanumeric characters along with - / : . are allowed e.g. 123-abc, 123/abc, 123:ABC, 123.ABC';
        executeNo();
        return;
      }
      this.validTermsAndConditions(executeNo, executeYes);
    //} else if (this.isGuestUserLoggedIn && this.activeIndex === 4) {
    } else if (!this.loginService.isUserBillLater() && this.activeIndex === 4) {
      // this.navigateToPaymentWhenGuestUser(executeYes, executeNo, this.workrequestComponent.totalOrderAmount, this.submitApplication.bind(this));
      this.navigateToPaymentWhenNonBillLaterUser(executeYes, executeNo, this.workrequestComponent.totalOrderAmount, this.submitApplication.bind(this));
    //} else if (this.isGuestUserLoggedIn && this.activeIndex === 5) {
    } else if (!this.loginService.isUserBillLater() && this.activeIndex === 5) {
      //this.navigateToPaymentWhenGuestUser(executeYes, executeNo, this.workrequestComponent.totalOrderAmount, this.submitApplication.bind(this));
      this.navigateToPaymentWhenNonBillLaterUser(executeYes, executeNo, this.workrequestComponent.totalOrderAmount, this.submitApplication.bind(this));
    } else {
      executeYes();
    }
  }

  goNext(): void {
    // if ((!this.isGuestUserLoggedIn && this.activeIndex === 4)
    //   || (this.isGuestUserLoggedIn && this.activeIndex === 5)) {
    //   return;
    // }
    if ((this.loginService.isUserBillLater() && this.activeIndex === 4)
      || (!this.loginService.isUserBillLater() && this.activeIndex === 5)) {
      return;
    }

    this.canGoNext(() => {
      this.activeIndex++;
    }, () => {
    });
  }

  canGoPrevious(): boolean {
    //if (this.isGuestUserLoggedIn && (this.activeIndex === 5 || this.activeIndex === 0)) {
    if (!this.loginService.isUserBillLater() && (this.activeIndex === 5 || this.activeIndex === 0)) {
      return false;
    }

    //if (!this.isGuestUserLoggedIn && this.activeIndex === 0) {
    if (this.loginService.isUserBillLater() && this.activeIndex === 0) {
      return false;
    }

    return true;
  }

  goPrevious(): void {
    if (!this.canGoPrevious()) {
      return;
    }

    this.activeIndex--;
  }

  get chm(): ApplicationBase {
    return this.chmService.applicationData;
  }

  get agreedToTsAndCs(): boolean {
    return this.chmService.agreedToTsAndCs;
  }

  set agreedToTsAndCs(v: boolean) {
    this.chmService.agreedToTsAndCs = v;
  }

  get submitErrorMessage(): string {
    return this.chmService.submitErrorMessage;
  }

  submitApplication(callback): void {

    let validData = true;
    this.chmService.submitErrorMessage = '';

    if (this.location.invalid) {
      this.chmService.submitErrorMessage += this.location.displayErrorMessage();
      validData = false;
    }

    this.workrequestComponent.errorMessage = this.workrequestComponent.displayErrorMessage();
    if (!this.workrequestComponent.invalid && this.workrequestComponent.errorMessage && this.workrequestComponent.errorMessage.length > 0) {
      this.chmService.submitErrorMessage += this.workrequestComponent.errorMessage;
      validData = false;
    }

    this.plumberDetailsComponent.errorMessage = null;
    if (this.plumberDetailsComponent.invalid) {
      this.chmService.submitErrorMessage += this.plumberDetailsComponent.displayErrorMessage();
      validData = false;
    }

    if (this.applicant.invalid) {
      this.chmService.submitErrorMessage += this.applicant.displayErrorMessage();
      validData = false;
    }

    if (!this.chmService.agreedToTsAndCs) {
      this.chmService.submitErrorMessage += 'Please select terms and conditions.';
      validData = false;
    }

    if (!validData) {
      return;
    }
    this.setApplicantData();
    this.chmService.applicationData.plumberDetails = this.plumberDetailsComponent.plumberDetails;
    this.chmService.applicationData.workrequestDetails = this.workrequestComponent.workRequestViewModel.workrequestDetails;
    this.chmService.applicationData.workrequestDetails.appendWorkRequestDescription(
      this.workrequestComponent.workRequestViewModel.newCheckMeterLocation);
    this.chmService.applicationData.locationAddress = this.location.addressDetails.locationAddress;
    this.doSubmit(callback);
  }

  newApplication(): void {
    window.location.reload();
    //super.newApplication();
    //this.workrequestComponent.markValidationControlsAsUntouched();
    //this.plumberDetailsComponent.markValidationControlsAsUntouched();
  }

  get shouldDisplayLocation(): boolean {
    return this.activeIndex === 0;
  }

  get shouldDisplayWorkRequest(): boolean {
    return this.activeIndex === 1;
  }

  get shouldDisplayPlumberDetails(): boolean {
    return this.activeIndex === 2;
  }

  get shouldDisplayApplicant(): boolean {
    return this.activeIndex === 3;
  }

  get shouldDisplayPaymentForm(): boolean {
    //return this.isGuestUserLoggedIn && this.activeIndex === 5;
    return !this.loginService.isUserBillLater() && this.activeIndex === 5;
  }

  get shouldDisplayNextButton(): boolean {
    // return (!this.isGuestUserLoggedIn && this.activeIndex !== 4)
    //   || (this.isGuestUserLoggedIn && (this.activeIndex !== 4 && this.activeIndex !== 5));
    return (this.loginService.isUserBillLater() && this.activeIndex !== 4) ||
           (!this.loginService.isUserBillLater() && (this.activeIndex !== 4 && this.activeIndex !== 5));
  }

  get shouldShowReviewAndSubmit(): boolean {
    return this.activeIndex === 4;
  }

  private doSubmit(callback): void {
    this.executeSubmit('chm', callback, this.workrequestComponent.totalOrderAmount, null, true);
  }

  protected loadFees() {
    this.workrequestComponent.retrieveFeesOkCb(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/create-application/chm-form/chm/chm.component.ts